import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";
import { $parse } from "../../../state";
import { MicrosoftLoginButton } from "./MicrosoftLoginButton";

export const MicrosoftLogin = observer(() => {
  const msalInstance = useMemo(
    () => new PublicClientApplication({ auth: $parse.auth.microsoft }),
    []
  );

  return (
    <MsalProvider instance={msalInstance}>
      {msalInstance && <MicrosoftLoginButton />}
    </MsalProvider>
  );
});
